/* The Clients page search box: which clients, and which of their projects, to show for what was typed.
   Same word-start matching as the instant suggestions (every typed word starts a word, any order, any case).
   - the client's name or one of its old names matches -> the client with ALL its projects
   - otherwise each project is checked on its name and its task names (words may also come from the client's name,
     so "acme website" finds Acme's Website project) -> the client with only those projects
   Nothing typed -> every client with all its projects (as before). */
import {matchesAll} from './match.ts';

interface C { id: string; name: string; aliases: string[] }
interface P { id: string; name: string }
interface T { name: string }
export interface ClientHit<CC, PP> { client: CC; clientMatch: boolean; projects: PP[]; total: number }

export function searchClients<CC extends C, PP extends P>(clients: CC[], projectsOf: (clientId: string) => PP[],
    tasksOf: (projectId: string) => T[], q: string[]): ClientHit<CC, PP>[] {
  const out: ClientHit<CC, PP>[] = [];
  for (const c of clients) {
    const all = projectsOf(c.id);
    if (!q.length) { out.push({client: c, clientMatch: false, projects: all, total: all.length}); continue; }
    const cText = [c.name, ...c.aliases].join(' \n ');
    if (matchesAll(cText, q)) { out.push({client: c, clientMatch: true, projects: all, total: all.length}); continue; }
    const projects = all.filter(p => matchesAll([cText, p.name, ...tasksOf(p.id).map(t => t.name)].join(' \n '), q));
    if (projects.length) out.push({client: c, clientMatch: false, projects, total: all.length});
  }
  return out;
}
